$(document).on('click', '.menu-collapse__head', function () {
    $(this).closest('.menu-collapse').toggleClass('menu-collapse--active');
});
